export function loadingIconTheme(theme, { getColor, getTextStyle }) {
  return {
    getCSS: ({ targetElement, color, isChecked }) => {
      switch (targetElement) {
        case 'loadingIcon': {
          return {
            color: theme.colors.indigo,
          };
        }

        default: {
          return null;
        }
      }
    },
  };
}
